<template>
  <b-modal
    hide-footer
    id="modal-mediate-appointment-detail"
    ref="modal-mediate-appointment-detail"
    size="lg"
    title="รายละเอียดนัดหมายไกล่เกลี่ย"
  >
    <b-row class="mb-2">
      <b-col cols="12">
        <hr class="my-12 bg-dark" />
      </b-col>
      <!-- <b-col cols="4" class="my-1">
        <span>เลขรับเรื่อง</span>
      </b-col>
      <b-col cols="8" class="my-1">{{ model.complaintCode }}</b-col>
      <b-col cols="12">
        <hr class="my-12 bg-dark" />
      </b-col> -->

      <b-col cols="12"><b class="">ข้อมูลผู้ร้องทุกข์</b></b-col>
      <b-col cols="12">
        <hr class="my-12 bg-dark" />
      </b-col>

      <b-col cols="4" class="my-1">
        <b>การยืนยันนัดหมาย</b>
      </b-col>
      <b-col cols="8" class="my-1">{{ model.isAppointmentNeedConfirm === true ? "ต้องยืนยันนัดหมาย" : "ไม่ต้องยืนยันนัดหมาย" }}</b-col>

      <b-col cols="4" class="my-1">
        <b>วันที่นัดหมาย</b>
      </b-col>
      <b-col cols="8" class="my-1"
        >{{ model.appointmentCustomerDateStr }} เวลา
        {{ model.appointmentCustomerStartTime }} - {{ model.appointmentCustomerEndTime }} น.</b-col
      >

      <b-col cols="4" class="my-1">
        <b>สถานที่</b>
      </b-col>
      <b-col cols="8" class="my-1">{{ model.customerMediateStr }}</b-col>

      <b-col v-if="model.customerMediate !== false" cols="12" class="my-1"
        ><a :href="model.customerMediateMeetingUrl" target="_blank"
          >Link Conferrence</a
        ></b-col
      >

      <b-col cols="12">
        <hr class="my-12 bg-dark" />
      </b-col>
      <b-col cols="12"><b class="">ข้อมูลผู้ถูกร้องทุกข์</b></b-col>
      <b-col cols="12">
        <hr class="my-12 bg-dark" />
      </b-col>

      <b-col cols="4" class="my-1">
        <b>การยืนยันนัดหมาย</b>
      </b-col>
      <b-col cols="8" class="my-1">{{ model.isAppointmentNeedConfirm === true ? "ต้องยืนยันนัดหมาย" : "ไม่ต้องยืนยันนัดหมาย" }}</b-col>

      <b-col cols="4" class="my-1">
        <b>วันที่นัดหมาย</b>
      </b-col>
      <b-col cols="8" class="my-1"
        >{{ model.appointmentCompanyDateStr }} เวลา
        {{ model.appointmentCompanyStartTime }} - {{ model.appointmentCompanyEndTime }} น.</b-col
      >

      <b-col cols="4" class="my-1">
        <b>สถานที่</b>
      </b-col>
      <b-col cols="8" class="my-1">{{ model.companyMediateStr }}</b-col>

      <b-col v-if="model.companyMediate !== false" cols="12" class="my-1"
        ><a :href="model.companyMediateMeetingUrl" target="_blank"
          >Link Conferrence</a
        ></b-col
      >
    </b-row>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BCard,
} from "bootstrap-vue";

import appsettings from "@/store/app-settings";
import * as userData from "@/auth/localStorageUtils.js";
import * as storeComplaint from "@/store/api/complaint/complaint.js";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BCard,
  },
  data() {
    return {
      model: {},
    };
  },
  mounted() {
    //console.log("modal mounted");
  },
  methods: {
    setModalData(complaintId, meetingData) {
      const _this = this;

      _this.model = meetingData;
    },
  },
};
</script>

<style></style>